import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { interval: { type: Number, default: 5000 } };

  connect() {
    this.timer = setInterval(() => {
      window.location.reload();
    }, this.intervalValue);
  }

  disconnect() {
    clearInterval(this.timer);
  }
}
